import React, { useState, useEffect, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import * as AlarmApi from "api/koach/v2/alarm.api";
import AlarmComponent from "./Index.component";
import { notificationListener } from "helpers/Firebase.helper";

const IndexContainer = (props: any) => {
  const location = useLocation();

  const [list, setList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);

  // pagination
  const searchParams = new URLSearchParams(location.search);
  const limit = 40;
  const [page, setPage] = useState(1);

  const getList = useCallback(async () => {
    console.log("/pages/koach/v2/alarm/Index.container:getList");
    console.log({ isLoading, hasMore })

    if (isLoading || !hasMore) return;

    setIsLoading(true);

    const result = await AlarmApi.getAlarmList(page, limit, true);
    console.log({ result })
    if (result?.list) {
      setList(prevList => [...prevList, ...result.list]);
      setPage(prevPage => prevPage + 1);
      setHasMore(result.list.length === limit);
    } else {
      setHasMore(false);
    }

    setIsLoading(false);
  }, [isLoading, hasMore, page, limit]);

  const handleScroll = () => {
    if (!hasMore) return;
    if (isLoading) return;

    const scrollHeight = document.documentElement.scrollHeight;
    const scrollTop = document.documentElement.scrollTop;
    const clientHeight = document.documentElement.clientHeight;

    if (Math.ceil(scrollTop + clientHeight) < scrollHeight - 100) return;

    getList();
  };

  const onClickCheckNotification = async (item: any) => {
    // 알림 클릭 처리 로직 (필요시 추가)
  };

  useEffect(() => {
    getList();
  }, []);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [handleScroll]);

  useEffect(() => {
    notificationListener.on("notification", getList);

    return () => {
      notificationListener.off("notification", getList);
    };
  }, [getList]);

  return (
    <AlarmComponent
      isLoading={isLoading}
      list={list}
      onClickCheckNotification={onClickCheckNotification}
      // pagination
      limit={limit}
      page={page}
      setPage={setPage}
      hasMore={hasMore}
    />
  );
};

export default IndexContainer;
